<template>
    <div class="statement bg_white" v-show="show">
        <div class="header">
            <div class="filter">
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">开始时间：</span>
                    <DatePicker type="datetimerange" format="yyyy-MM-dd HH:mm:ss" :value="dateValue" @on-change="dateChange"
                                placeholder="请选择" style="width: 250px"></DatePicker>
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">订单编号：</span>
                    <input type="text" @blur="orderNoChange" />
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">电话号码：</span>
                    <input type="text" @blur="phoneChange" />
                </div>
                <div class="fl f14 bold400 txt_black85" style="margin-left: 20px">
                    <span class="fl">已收：</span>
                    <span v-text="all_amount"></span>
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">退款：</span>
                    <span v-text="all_tui_amount"></span>
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">实收：</span>
                    <span v-text="all_real_amount"></span>
                </div>
            </div>
            <button type="back" class="fr" @click="backEvent">返回</button>
            <button v-if="this.role==='agent'||this.role==='partner'" type="create" class="fr" @click="exportEvent">导出报表</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @refundEvent="refundEvent"></lists>
    </div>
</template>
<!--
    .
-->
<script>
    import Lists from '@/components/Lists'
    import {mapGetters} from "vuex";
    
    export default {
        name: "statement",
        components: {
            Lists
        },
        data() {
            return {
                show: false,
                point_name: null,
                filter: {},
                dateValue: [null,null],
                all_amount: 0,
                all_real_amount: 0,
                all_tui_amount: 0,
                lists: {
                    title: [{text: '订单编号'}, {text: '柜门'}, {text: '规格'}, {text: '订单缴费开始时间'}, {text: '订单缴费结束时间'},
                        {text: '订单结束时间'}, {text: '支付时间'}, {text: '电话'}, {text: '订单状态'}, {text: '已收'}, {text: '退款'},
                        {text: '实收'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '12%', textAlign: 'left'},
                    {width: '5%', textAlign: 'center'},
                    {width: '5%', textAlign: 'center'},
                    {width: '11%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '8%', textAlign: 'left'},
                    {width: '6%', textAlign: 'center'},
                    {width: '5%', textAlign: 'center'},
                    {width: '5%', textAlign: 'center'},
                    {width: '5%', textAlign: 'center'},
                    {width: '5%', textAlign: 'left'}
                ],
                httpRequestData: {
                    url: '/manage/turnover',
                    func: this.httpRequestHandle,
                    error: '获取流水信息出错',
                    auto: false,
                    getData: this.getTurnoverDate
                },
            }
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        methods: {
            init(point_id,point_name) {
                this.show = true;
                this.point_name = point_name;
                this.filter.point_id = point_id;
                this.setDate();
                this.$refs.lists.updateData(this.filter);
            },
            closeEvent() {
                this.show = false;
            },
            getTurnoverDate(data) {
                this.all_amount = data.all_amount;
                this.all_real_amount = data.all_real_amount;
                this.all_tui_amount = data.all_tui_amount;
                return data.data;
            },
            httpRequestHandle(data) {
                let operation = this.role === 'agent' || this.role === 'partner' ? {text: '-----'} : {
                    arr: [
                        {text: '退款', style: {color: '#FF2118'}, event: 'refundEvent'},
                    ]
                };
                return data.map(item =>{
                    let refund = item.status === 2 ? item.price : 0;
                    return [
                        {text: item.order_no},
                        {text: item.door_no},
                        {text: this.$config.doorType.get(item.door_type)},
                        {text: item.start_time},
                        {text: item.end_time},
                        {text: item.order_status !==0 ? item.finish_time : '--------'},
                        {text: item.pay_time},
                        // {text: item.user_name},
                        {text: item.phone},
                        {text: this.$config.orderStatus.get(item.order_status)},
                        {text: item.price},
                        {text: refund},
                        {text: item.price - refund},
                        operation
                    ]
                });
            },
            refundEvent(data) {
                if(data.status === 2) {
                    this.$modal({content: '该单据不能退款'});
                    return;
                }
                this.$api.get('/manage/refundOfRealPay',{
                    id: data.id
                }).then((data) => {
                    this.$alert.success({content: '退款成功'});
                }).catch((error) => {
                    this.$alert.error({content: '退款出错:' + error});
                })
            },
            setDate() {
                let date_start = new Date();
                let time_start = date_start.getFullYear()+'-'+(date_start.getMonth()+1)+'-'+date_start.getDate() + ' 00:00:00';
                // let date_end = new Date(date_start.getTime() + 24*60*60*1000);
                // let time_end = date_end.getFullYear()+'-'+(date_end.getMonth()+1)+'-'+date_end.getDate();
                let time_end = date_start.getFullYear()+'-'+(date_start.getMonth()+1)+'-'+date_start.getDate() + ' 23:59:59';
                this.filter.time_start = time_start;
                this.filter.time_end = time_end;
                this.dateValue = [time_start,time_end];
            },
            dateChange(date) {
                this.dateValue = date;
                this.filter.time_start = date[0];
                this.filter.time_end = date[1];
                this.$refs.lists.updateData(this.filter);
            },
            orderNoChange(event) {
                this.filter.order_no = event.target.value || '';
                this.$refs.lists.updateData(this.filter);
            },
            phoneChange(event) {
                this.filter.phone = event.target.value || '';
                this.$refs.lists.updateData(this.filter);
            },
            backEvent() {
                this.show = false;
                this.$emit('navigation','point');
            },
            exportEvent() {
                this.$api.post('/manage/statement',this.filter).then((data) => {
                    let array = data.path.split('.');
                    let suffix = array[array.length-1];
                    let downloadElement = document.createElement('a');
                    downloadElement.href = 'https://manage.scadkj.com/' + data.path;
                    downloadElement.download = this.point_name + this.dateValue[0].split(' ')[0] + ' - ' + this.dateValue[1].split(' ')[0] + '.' + suffix;
                    downloadElement.style.display = 'none';
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                }).catch((error) => {
                    this.$alert.error({content: '导出出错:' + error});
                })
            }
        }
    }
</script>

<style scoped>
    .statement {
        padding: 0 5px;
    }

    .statement > .header {
        height: 80px;
        padding: 0 15px;
    }

    .statement > .header > button {
        margin-top: 20px;
        margin-left: 20px;
    }

    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }

    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
        padding: 0 5px;
    }
</style>